import {makeStyles} from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
    inquiryContainer: {
        display: 'flex',
        background: 'white',
        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
        borderRadius: '8px',
        padding: '20px',
        textAlign: 'center',
        margin: '10px 10px',
    },
    textField: {
        marginBottom: 20,
    },
}));
